import { render } from "./ItemCounter.vue?vue&type=template&id=71a42b71&lang=pug"
import script from "./ItemCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemCounter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__